export const formFields = [
  {
    section: "section 1",
    name: "cpfGpiListName",
    label: "List",
    fieldLabel: "CPF GPI List Name",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [5, 17],
  },
  {
    section: "section 1",
    name: "cpfGpiListDescription",
    label: "Description",
    fieldLabel: "CPF GPI List Description",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 30, message: "MAXLENGTH_30" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [6, 17],
  },
  {
    section: "Audit Fields",
    name: "addDate",
    label: "Added",
    fieldLabel: "Added",
    type: "date",
    format: "MM/DD/YYYY",
    fieldNature: "Add: Non-Display, Change: Read-Only, View: Read-only",
    position: [9, 13],
  },
  {
    section: "Audit Fields",
    name: "chgDate",
    label: "Changed",
    fieldLabel: "Changed",
    type: "date",
    format: "MM/DD/YYYY",
    fieldNature: "Add: Non-Display, Change: Read-Only, View: Read-only",
    position: [9, 33],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "User",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-Only, View: Read-only",
    position: [9, 50],
  },
  {
    section: "Audit Fields",
    name: "noteExistenceStatus",
    label: "Note Exists",
    fieldLabel: "Note Existence Status",
    type: "text",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [9, 70],
  },
];
